import classNames from "classnames";
import { forwardRef, LabelHTMLAttributes } from "react";

import { Optional, StyledLabel } from "./FieldLabel.styled";

import { getTranslationManually } from "src/helpers/locale";

export type FieldLabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  /**
   * Set label with required mark
   * @default {false}
   */
  required?: boolean;

  /**
   * Set label with optional mark
   * @default {false}
   */
  optional?: boolean;

  /**
   * Set label with optional mark with no parenthesis
   * @default {false}
   */
  optionalWithNoParenthesis?: boolean;

  /**
   * Additional info component (ex: tooltip)
   * @default {null}
   */
  info?: React.ReactChild;
};

const defaultProps = {
  required: false,
  optional: false
};

const FieldLabel = forwardRef<HTMLLabelElement, FieldLabelProps>((props, ref) => {
  const { children, className, required, optional, optionalWithNoParenthesis, info, ...restProps } = props;
  const labelClass = classNames("c-field-label", className);

  return (
    <StyledLabel ref={ref} className={labelClass} data-testid="qa-field-label" {...restProps}>
      {children}
      {required && (
        <span className="u-text-ketchup-tomato u-text-medium" data-testid="qa-field-label-required">
          *
        </span>
      )}
      {(optional || optionalWithNoParenthesis) && (
        <Optional data-testid="qa-field-label-optional">
          {optionalWithNoParenthesis
            ? getTranslationManually("Opsional", "Optional")
            : `(${getTranslationManually("Opsional", "Optional")})`}
        </Optional>
      )}
      {info}
    </StyledLabel>
  );
});

FieldLabel.defaultProps = defaultProps;

export default FieldLabel;
